import ReactPlayer from 'react-player'

const Trailers = () => (
    <>
        <h1 className='trailer-title'>Launch Trailer (Nintendo Switch, PS4, PC)</h1>
        <div className='video-container'>
            <div className='video-wrapper'>
                <ReactPlayer url='https://www.youtube.com/watch?v=S6JVtleWmdg' />
            </div>
        </div>

        <h1 className='trailer-title'>Gameplay Trailer</h1>
        <div className='video-container'>
            <div className='video-wrapper'>
                <ReactPlayer url='https://www.youtube.com/watch?v=4QS2aUIMIac' />
            </div>
        </div>

        <h1 className='trailer-title'>Character Trailer</h1>
        <div className='video-container'>
            <div className='video-wrapper'>
                <ReactPlayer url='https://www.youtube.com/watch?v=c46hyVWdvKc' />
            </div>
        </div>
        <h1 className='trailer-title'>Teaser Trailer (Nintendo Switch, PS4, PC)</h1>
        <div className='video-container'>
            <div className='video-wrapper'>
                <ReactPlayer url='https://www.youtube.com/watch?v=lAOCKcEbjiY' />
            </div>
        </div>
        <h1 className='trailer-title'>Story Trailer</h1>
        <div className='video-container'>
            <div className='video-wrapper'>
                <ReactPlayer url='https://www.youtube.com/watch?v=YVhbUvmWacU' />
            </div>
        </div>
    </>
)

export default Trailers
